export default "__VITE_ASSET__upp8DLFw__"